// Sorteert maten van klein naar groot voor weergave (maatknoppen, maattabel).
// Ondersteunt letter-maten (S/M/L…), pure cijfers (38, 104) en kinder-maatparen
// (50/56, 74/80). Onherkenbare maten blijven achteraan staan, in de volgorde
// waarin ze al stonden (stabiele sort).
const LETTER_ORDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "2XL", "3XL", "4XL", "5XL", "6XL"];

function sizeSortKey(size: string): number {
  const s = String(size || "").trim().toUpperCase();
  const letterIdx = LETTER_ORDER.indexOf(s);
  if (letterIdx !== -1) return letterIdx;
  if (/^\d+$/.test(s)) return Number(s);
  const pair = s.match(/^(\d+)\s*[/\-]\s*(\d+)/);
  if (pair) return Number(pair[1]);
  const leadingNumber = s.match(/^(\d+)/);
  if (leadingNumber) return Number(leadingNumber[1]);
  return Infinity;
}

export function sortSizes<T>(sizes: T[], toLabel: (item: T) => string = (item) => String(item)): T[] {
  return [...sizes].sort((a, b) => sizeSortKey(toLabel(a)) - sizeSortKey(toLabel(b)));
}
